/** BookingsTabBody — the active tab's list (BON-490), extracted from
 *  BookingsCard so its own render function stays under the size cap. Wrapped
 *  as the ARIA tabpanel that pairs with the active BookingsTab's
 *  `id`/`aria-controls`. */
import type { WorkshopReservation, WorkshopRoster } from '../../../../api/workshops';

import type { TabId } from './bookingsCardTypes';
import { BookingsRosterList } from './BookingsRosterList';
import { TreeReplacementsList, type TreeReplacementsListProps } from './TreeReplacementsList';
import { WorkshopReservations } from './WorkshopReservations';

export function BookingsTabBody({
  tab,
  roster,
  reservations,
  treeReplacements,
  canManage,
}: {
  tab: TabId;
  roster: WorkshopRoster;
  reservations: WorkshopReservation[];
  treeReplacements: TreeReplacementsListProps;
  canManage: boolean;
}) {
  // The list flows with the page rather than scrolling inside its own box (the
  // page is already the scroll container).
  return (
    <div role="tabpanel" id={`panel-${tab}`} aria-labelledby={`tab-${tab}`} tabIndex={0}>
      {tab === 'bookings' && <BookingsRosterList bookings={roster.bookings} />}
      {tab === 'reservations' && (
        <WorkshopReservations
          reservations={reservations}
          reservedSeats={roster.reservedSeats}
          canManage={canManage}
        />
      )}
      {tab === 'tree-replacements' && <TreeReplacementsList {...treeReplacements} />}
    </div>
  );
}
